import { z as requireObjectCoercible, A as toIntegerOrInfinity, _ as _export } from '../../../common/classof-d5e7087e.js';
import { t as toString_1 } from '../../../common/to-string-1a1208e1.js';
import { e as entryUnbind } from '../../../common/entry-unbind-02eb97f8.js';
import '../../../common/_commonjsHelpers-6d0ad781.js';

var $RangeError = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
var stringRepeat = function repeat(count) {
  var str = toString_1(requireObjectCoercible(this));
  var result = '';
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n === Infinity) throw new $RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
_export({ target: 'String', proto: true }, {
  repeat: stringRepeat
});

var repeat = entryUnbind('String', 'repeat');

export default repeat;
